import { PARTNER_STATUS_LABEL, type PartnerStatus } from "@colab/shared";
import { cn } from "@/lib/utils";

const STYLES: Record<PartnerStatus, string> = {
  active: "bg-status-active/10 text-status-active ring-status-active/25",
  inactive: "bg-muted text-muted-foreground ring-border",
  churned: "bg-status-lost/10 text-status-lost ring-status-lost/25",
};

export function PartnerStatusBadge({
  status,
  className,
}: {
  status: PartnerStatus;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider ring-1",
        STYLES[status],
        className,
      )}
    >
      <span
        aria-hidden
        className={cn(
          "inline-block h-1.5 w-1.5 rounded-full",
          status === "active" && "bg-status-active",
          status === "inactive" && "bg-muted-foreground",
          status === "churned" && "bg-status-lost",
        )}
      />
      {PARTNER_STATUS_LABEL[status]}
    </span>
  );
}
